export enum ShipmentStatus {
  UNSORTED = 'unsorted',
  SORTED = 'sorted',
  MANIFESTED = 'manifested',
  VOIDED = 'voided',
}

export interface Shipment {
  id: string;
  carrierAccountKey: string;
  tags: string[];
  createdAt: string;
  sortedAt: string;
  manifestedAt: string;
  status: ShipmentStatus;
  references: string[];
}

export type SortableShipmentKey =
  | 'carrierAccountKey'
  | 'createdAt'
  | 'sortedAt'
  | 'manifestedAt'
  | 'status'
  | 'references';

export interface GetShipmentsQuery {
  carrierAccountKeys?: string[];
  references?: string[];
  tags?: string[];
  status?: ShipmentStatus[];
  isVoided?: boolean;
  isSorted?: boolean;
  isManifested?: boolean;
  createdBefore?: string;
  createdAfter?: string;
  sortedBefore?: string;
  sortedAfter?: string;
  manifestedBefore?: string;
  manifestedAfter?: string;
  palletBoxId?: string;
  limit?: number;
  page?: number;
  sort?: [SortableShipmentKey, 'ASC' | 'DESC'][];
}

export interface GetShipmentsResult {
  shipments: Shipment[];
  count: number;
  limit: number;
  page: number;
}

export interface ShipmentsService {
  getShipments(query: GetShipmentsQuery): Promise<GetShipmentsResult>;
}
